import styled from 'styled-components';
import { COLORS } from '../constants';

/** Shared arcade-style yellow pill button used by the start / game-over overlays. */
const PlayButton = styled.button`
  background: ${COLORS.yellow};
  color: ${COLORS.black};
  border: none;
  border-radius: 40px;
  padding: 14px 40px;
  font-size: 17px;
  font-weight: 800;
  cursor: pointer;
  font-family: 'Open Sans', sans-serif;
  letter-spacing: 0.5px;
  transition:
    transform 0.15s,
    box-shadow 0.15s;
  box-shadow: 0 4px 20px rgba(245, 180, 0, 0.4);

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 28px rgba(245, 180, 0, 0.6);
  }
`;

export default PlayButton;
